import React from "react";
import { ShieldCheck, Leaf } from "lucide-react";
const logos = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/partner_logo_buildpro.png",
  alt: "American Dental Association"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/partner_logo_renovate.png",
  alt: "American Academy of Sleep Medicine"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/partner_logo_construct.png",
  alt: "Blue Cross Blue Shield"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/partner_logo_homecraft.png",
  alt: "Aetna Insurance"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/partner_logo_elitebuilders.png",
  alt: "Cigna Healthcare"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1612048/img/partner_logo_cityworks.png",
  alt: "UnitedHealthcare"
}];
export default function TrustedByProsAndHomeowners() {
  return <section data-section-id="125017" id="trusted-certifications" className="bg-background text-foreground">
      <style>{`
        @keyframes scroll {
          to { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 40s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
      
      <div className="bg-accent/50 border-y border-border py-10 overflow-hidden">
        <div className="container mx-auto px-4">
          
          {}
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-10 text-xs font-bold text-primary/70 uppercase tracking-widest">
            <div className="flex items-center gap-2">
              <ShieldCheck className="size-5 text-secondary" />
              <span>Board Certified</span>
            </div>
            
            <div className="text-center text-primary normal-case tracking-tight text-lg md:text-xl font-bold">
              Trusted by Leading Medical Institutions & Insurance Providers
            </div>
            
            <div className="flex items-center gap-2">
              <Leaf className="size-5 text-secondary" />
              <span>FDA Cleared Solutions</span>
            </div>
          </div>

          {}
          <div className="relative flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
            <div className="flex w-max animate-scroll">
              
              {}
              <div className="flex gap-16 pr-16 items-center">
                {logos.map((logo, i) => <div key={logo.id} data-index={i} className="flex-none w-32 md:w-40 flex items-center justify-center">
                    <img src={logo.src} alt={logo.alt} className="h-8 md:h-10 w-auto object-contain opacity-40 grayscale transition-all duration-500 hover:opacity-100 hover:grayscale-0 cursor-pointer" />
                  </div>)}
              </div>
              
              {}
              <div className="flex gap-16 pr-16 items-center" aria-hidden="true">
                {logos.map((logo, i) => <div key={`dup-${logo.id}`} data-index={i + logos.length} className="flex-none w-32 md:w-40 flex items-center justify-center">
                    <img src={logo.src} alt={logo.alt} className="h-8 md:h-10 w-auto object-contain opacity-40 grayscale transition-all duration-500 hover:opacity-100 hover:grayscale-0 cursor-pointer" />
                  </div>)}
              </div>
              
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}